import React, { Component } from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import Typography from '@mui/material/Typography'

// Components
import HeadGlobal from './headerGlobal'
// Utils
import {
  welcomeEs,
  welcomeFr,
  welcomeEn,
  welcomePtg,
} from '../textApp/textTrad'
import { navigationGA } from '../data/GA'
import { checkAllQuotas } from '../data/saveSurvey'

class NotUserPage extends Component {
  constructor(props) {
    super(props)
    this.selectLang = this.selectLang.bind(this)
  }
  async componentDidMount() {
    setTimeout(() => {
      localStorage.removeItem('dataUser')
    }, 5000)
    navigationGA('No Survey', 'nosurvey', 'noSurvey')
    const infos = await checkAllQuotas('fr')
    console.log(infos)
    return null
  }

  //   static getDerivedStateFromProps(nextProps, prevState) {
  //     const {
  //       navigate,
  //       params,
  //       setlang,
  //     } = nextProps

  //     if (!!params.id && !!params.lng && !!params.ctg) {
  //       const lang =
  //         params.lng === 'aa' ? 'en' : params.lng === 'bb' ? 'fr' : 'es'
  //       setlang(lang)
  //       setSocDis(params.sd)
  //       setCatego(params.ctg)
  //       setUserId(params.id)
  //       localStorage.setItem(
  //         'dataUser',
  //         JSON.stringify({
  //           id: params.id,
  //           catego: params.ctg,
  //           socDis: params.sd,
  //           lng: lang,
  //         })
  //       )
  //     } else {
  //       navigate('/ended')
  //     }
  //     return null
  //   }

  // componentDidMount() {
  //   setTimeout(() => {
  //     window.open('https://app.prolific.co/submissions/complete?cc=1F3B22AD')
  //   }, 2000)
  // }
  selectLang = () => {
    const { lng } = this.props
    switch (lng) {
      case 'es':
        return welcomeEs
      case 'fr':
        return welcomeFr
      case 'en':
        return welcomeEn
      case 'pt':
        return welcomePtg
      default:
        return welcomeEn
    }
  }

  render() {
    const { setlang } = this.props
    const txt = this.selectLang()
    const text = [{ eso: false }, { isConnected: true }]
    const prev = text[1] ? text[1].isConnected || false : false
    const userBef = JSON.parse(localStorage.getItem('dataUser'))
    const user = (userBef || '').existUser
    return (
      prev && (
        <div className='center'>
          <div className='main'>
            <CssBaseline>
              <HeadGlobal setlang={setlang} changeLang={true} />
              <Typography
                component='h1'
                variant='h4'
                align='center'
                sx={{
                  fontWeight: '700',
                  paddingBottom: '2vh',
                  fontSize: {
                    xs: '1.5rem',
                    sm: '1.5rem',
                    md: '2rem',
                  },
                }}
              >
                {user ? txt.title1End : txt.title}
              </Typography>
              <Typography
                component='h4'
                variant='h5'
                align='center'
                sx={{
                  fontSize: {
                    xs: '1.3rem',
                    sm: '1.4rem',
                    md: '1.5rem',
                  },
                }}
              >
                {user ? txt.defaultUserExist : txt.default1NotUser}
                <br />
                <br />
              </Typography>
              <Typography
                component='h4'
                variant='h5'
                align='center'
                sx={{
                  fontSize: {
                    xs: '1.3rem',
                    sm: '1.4rem',
                    md: '1.5rem',
                  },
                }}
              >
                {user ? '' : txt.default2NotUser}
                <br />
              </Typography>
              <Typography
                component='h4'
                variant='h5'
                align='center'
                paddingTop='2vh'
                sx={{
                  fontSize: {
                    xs: '1.3rem',
                    sm: '1.4rem',
                    md: '1.5rem',
                  },
                }}
              >
                {txt.default3NotUser}
                <br />
                <br />
              </Typography>
              <Typography
                component='h2'
                variant='h4'
                align='center'
                sx={{
                  fontWeight: '700',
                  paddingBottom: '1vh',
                  fontSize: {
                    xs: '1.3rem',
                    sm: '1.4rem',
                    md: '1.5rem',
                  },
                }}
              >
                {txt.endThanks}
              </Typography>
            </CssBaseline>
          </div>
        </div>
      )
    )
  }
}

export default NotUserPage
